import React, { useRef, useState } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button
} from "@chakra-ui/react";
import { raiseEmergencyAction } from '../../Action/callAction';
import { ShowAlert } from '../../../../GlobalComponents/ShowAlert/ShowAlert';
// import { set } from 'react-ga';
// import { ShowAlert } from '../../../../GlobalComponents/Toastify/toastify';

interface AlertDialogCompoProps {
  isEmergencyOpen: boolean;
  onEmergencyClose: () => void;
  benId:string;
  mobile:string;
  lat:string|null;
  lng:string|null;

}

const AlertDialogCompo: React.FC<AlertDialogCompoProps>=({ isEmergencyOpen ,onEmergencyClose, benId, mobile, lat, lng}) => {

  const cancelRef = useRef<HTMLButtonElement | null>(null);
  const [loading,setLoading] = useState(false);

  const HandleEmergencyClick = async() => {
    if(!mobile){
      ShowAlert('warning','Please update mobile number to account')
    }
    try{
      setLoading(true)
      let res = await raiseEmergencyAction(benId,mobile,lat,lng)
      // pets.includes('cat')
    
      if(res?.data?.message){
        ShowAlert('success',`${res?.data?.message} Please wait, Our team will reach out to you soon!`||"Some technical issue in raising emergency. Please  reach out to our team")
      }else{
        ShowAlert('error','Some technical issue in raising emergency. Please  reach out to our team')
      }
      onEmergencyClose()
        setLoading(false)
    }catch(e:any){
      console.log(e)
    }
  };

  return (
    <>
      <AlertDialog
        isOpen={isEmergencyOpen}
        leastDestructiveRef={cancelRef}
        onClose={onEmergencyClose}
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Emergency Call
          </AlertDialogHeader>
          <AlertDialogBody>
            Is there an urgent need for an emergency call?
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onEmergencyClose}>
              Cancel
            </Button>
            <Button 
              colorScheme="green" 
              onClick={HandleEmergencyClick} 
              ml={3}
              isLoading={loading}
              loadingText="Calling..."
            >
              Make Call
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}

export default AlertDialogCompo;
